export default {
      id: "eld_status_D-usage",
      viewBox: "0 0 15 15",
      url: __webpack_public_path__ + "img/icons.svg#eld_status_D",
      toString: function () {
        return this.url;
      }
    }